<template>
  <div class="change-phone">
    <auth-button opt="change_phone" v-if="idDirectAgent()" @click.native="toChangePhone" :loading="btnLoading" label="更换"></auth-button>
    <el-dialog
      :visible="dialogVisible"
      size="small"
      @close="closeDialog"
      width="500px"
      :modal="false"
    >
      <el-form
        label-width="100px"
        :model="formData"
        :rules="rules"
        align="center"
        class="change-phone-form"
        ref="changePhone"
      >
        <el-form-item
          label="现有绑定手机"
          prop="currentMobile"
          :error="changePhoneError"
        >
          <el-input
            placeholder="请输入11位正确手机号"
            v-model="formData.currentMobile"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="短信验证码"
          prop="validCode"
        >
          <div class="change-phone__verify-code">
            <el-input
              placeholder="请输入验证码"
              v-model="formData.validCode"
              class="change-phone__vc-in"
            ></el-input>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg"
              v-if="count===60"
              :loading="sendMsgLoading"
            >
              获取验证码
            </el-button>
            <el-button
              class="change-phone__vc-get"
              @click="sendMsg"
              v-else
              disabled
            >
              {{ count }}s
            </el-button>
          </div>

        </el-form-item>
        <el-form-item label="新的绑定手机" prop="newMobile">
          <el-input
            placeholder="请输入11位正确手机号"
            v-model="formData.newMobile"
          ></el-input>
        </el-form-item>
        <div>
          <el-button
            type="primary"
            @click="confirm"
            :loading="confirmLoading"
          >
            确认
          </el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import { modifyMerchantMobile, getModifyMobileCode, preModifyMobile } from '@/api/global'
export default {
  props: {
    merchantId: {
      type: String,
      required: true
    },
    fAgentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      formData: {
        currentMobile: '',
        validCode: '',
        newMobile: ''
      },
      changePhoneError: '',
      rules: {
        currentMobile: [
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        newMobile: [
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        validCode: [
          { validator: this.validateVerifyCode, trigger: 'blur' }
        ]
      },
      count: 60,
      timer: null,
      sendMsgLoading: false,
      confirmLoading: false,
      btnLoading: false
    }
  },
  methods: {
    validatePhone (rule, value, callback) {
      this.changePhoneError = ''
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('请输入11正确手机号'))
        }
        callback()
      }
    },
    validateVerifyCode (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码'))
      }
      callback()
    },

    closeDialog () {
      this.dialogVisible = false
      this.resetForm()
    },
    confirm () {
      this.$refs.changePhone.validate((valid) => {
        if (valid) {
          const { newMobile, validCode } = this.formData
          this.confirmLoading = true
          modifyMerchantMobile({
            newMobile,
            validCode,
            merchantId: this.merchantId
          }).then(data => {
            if (data.result_cde === '0') {
              this.$message.success('更换成功')
              this.resetTimer()
              this.closeDialog()
              this.$emit('change', newMobile)
            } else {
              this.$message.error(data.result_msg)
            }
            this.confirmLoading = false
          })
        }
      })
    },
    cancel () {
      this.dialogVisible = false
      this.resetForm()
    },
    sendMsg () {
      const { currentMobile } = this.formData
      if (!currentMobile) {
        this.changePhoneError = '请输入手机号'
        return
      }
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(currentMobile))) {
        this.changePhoneError = '请输入11正确手机号'
        return
      }
      this.sendMsgLoading = true
      getModifyMobileCode({
        currentMobile,
        merchantId: this.merchantId
      }).then(data => {
        if (data.result_cde === '-1002') {
          this.changePhoneError = data.result_msg
        } else if (data.result_cde === '-1001') {
          this.$message.error(data.result_msg)
        } else if (data.result_cde.toString() === '0') {
          this.countOperation()
        }
        this.sendMsgLoading = false
      })
    },
    resetForm () {
      this.changePhoneError = ''
      this.$refs.changePhone.resetFields()
    },
    countOperation () {
      this.timer = setInterval(() => {
        this.count = this.count - 1
        if (this.count === 0) {
          this.resetTimer()
        }
      }, 1000)
    },
    resetTimer () {
      clearInterval(this.timer)
      this.count = 60
    },
    /**
             * 判断是否是直属代理
             */
    idDirectAgent () {
      const directAgentId = this.$store.getters.userId
      if (directAgentId === this.fAgentId) {
        return true
      } else {
        return false
      }
    },
    /**
             * 更换手机号
             */
    toChangePhone () {
      const that = this
      const params = qs.stringify({
        merchantId: that.merchantId
      })
      this.btnLoading = true
      preModifyMobile(params).then(data => {
        that.btnLoading = false
        if (data.result_cde === '0') {
          that.dialogVisible = true
        } else if (data.result_cde === '1') {
          that.$emit('updateInit', data.mobile)
          that.dialogVisible = true
        } else {
          that.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        }
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      this.resetTimer()
    }
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .change-phone {
        display: inline-block;
        &__verify-code {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        &__vc-in {
            width: 220px;
        }
        &__vc-get {
            width: 120px;
        }
        & .el-form-item {
            margin-bottom: 25px;
        }
    }

</style>
